const ALL_LOCALES = [
  { id: 'en', name: 'English', flag: 'flag-US' },
  {
    id: 'ar', name: 'العربية', direction: 'rtl', flag: 'flag-KW',
  },
]

export default ALL_LOCALES
